export default "__VITE_ASSET__35a21db5__"